export default "__VITE_ASSET__DSp2UyTs__"